<template>
    <v-dialog v-model="dialog" :max-width="confirm.width" persistent overlay-opacity="0.75">
        <v-toolbar dark :color="(confirm.color ? confirm.color : 'orange') + ' darken-4'" dense>
            <v-toolbar-title class="white--text">{{ confirm.title }}</v-toolbar-title>
        </v-toolbar>
        <v-card tile class="grey darken-3">
            <v-card-text v-if="confirm.msg" color="red" v-html="confirm.msg"/>
            <v-card-actions>
                <v-btn color="grey" text @click="onCancel()">{{ confirm.cancel }}</v-btn>
                <v-spacer/>
                <v-btn :color="(confirm.color ? confirm.color : 'orange') + ' darken-4'" @click="onConfirm()">{{ confirm.confirm }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ConfirmDialog',
    components: {},
    props: {
        confirm: { type: Object, default: {}, required: true, },
    },
    data: () => ({
        dialog: false,
    }),
    computed: {
    },
    methods: {
		onCancel() {
            this.$emit('cancel')
            this.dialog = false
		},
		onConfirm() {
            this.$emit('confirm')
            this.dialog = false
		},
    },
    mounted() {
        this.dialog = true
    },
    beforeDestroy() {
    },
    watch: {
    },
}
</script>
<style scoped>
</style>